<template>
    <v-app id="empty">
      <v-main>
       <v-container fluid>
        <v-row cols="12">  
          <v-col cols="12" class="px-1"> <!-- Links -->
            <v-card class="ma-2">
                <v-data-table 
                    :items="items" 
                    :search="search"
                    :fixed-header="fixedHeader" 
                    :headers="headers" 
                    :height="fixedHeader ? table_height : null"
                    :disable-pagination=true 
                    no-data-text="No accommodations to display" 
                    :hide-default-footer="true" 
                >
            <template v-slot:top>
                <v-text-field v-if="searchfield"
                v-model="search"
                prepend-icon="mdi-magnify"
                label="Search through all fields"
                class="mx-4 searchfield"
                ></v-text-field>
            </template>
            <template v-slot:item="props">
                <tr>
                <td class="image-alignment">
                    <div class="image-borders" style="cursor: pointer;">
                        <v-img :src="props.item.photo" width="125px" height="100px"  @click="$router.open('/huis/onHuisPhotographer/' + props.item.huis_encrid)"></v-img>
                    </div>
                </td>
                <td @click="$router.open('/huis/onHuisPhotographer/' + props.item.huis_encrid)" class="td-markup">
                    <div><a> {{ props.item.huis_code }} </a></div>
                    <div class="default-cursor"></div>
                    <div class="default-cursor"></div>
                </td>
                </tr> 
            </template>

        </v-data-table>
            </v-card>
          </v-col>
        </v-row>

       </v-container>
      </v-main>
      <navBar title="Ares - Main menu" type="photographer"/>
    </v-app>
  </template>

<script>
  import navBar from "@/components/ui/navbars/navbar.vue";
  export default {
    components: {
      navBar,
    },
    data() {
      return {
            localStorageItemStat: 'search.acco.statcodes',
            localStorageItemBedr: 'search.acco.bedrcodes',
            results: false,
            statCodesSelected: [],
            statCodes: [],
            plts_nrKeuzes: [],
            plts_nr: '',
            gebrCodesSelected: [],
            gebrCodes: [],
            bedrCodesSelected: [],
            bedrCodes: [],
            items: [],
            huis_code: '',
            huis_naam: '',
            eign_naam: '',
            eign_email: '',
            partner_acco_id: '',
            param: {},
            searchCityInput: '',
            search: '',
            fixedHeader: true,
            headers: [],
            table_height:'',
            searchfield: false,
        } 
    },
    methods: {
      updateData(data) {
        this[data.field] = data.value;
      },
      getAccos() {
        this.results = true;
        this.$axios
        .post("ares/json/ares/huis/searchHuisPhotographer.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchHuisPhotographer"
          },
          searchHuisPhotographer: {
            
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            // set hustcode and company selection into local storage after successful search                       
            //localStorage.setItem(this.localStorageItemStat, this.statCodesSelected);
            //localStorage.setItem(this.localStorageItemBedr, this.bedrCodesSelected);

            this.items = res.data.searchHuisPhotographer;
            if (res.data.color == "warning") {
              this.$store.dispatch('setSnackbar', {
                showing: true,
                text: res.data.text,
                color: res.data.color
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
      }
    },
    mounted() {
      this.getAccos()

    }
  }
</script> 
  